import { useMutation } from '@tanstack/react-query';
import { ObjectMap, useApiGet, useApiQuery } from 'mf_core/query';
import { getRevisionNumber } from '../internal/TSProduct.utils';
import {
  CartSummaryResponseTO,
  PlanLineTO,
  ProductSummaryTO,
  TotalTO,
} from '../../CloudAddToCartButton/common/types';

export function useGetQuoteSummaryQuery() {
  let quoteDetails: any = sessionStorage.getItem('quoteDetails');
  quoteDetails = quoteDetails ? JSON.parse(quoteDetails) : null;
  const params = {
    quoteGuid: quoteDetails?.quoteguid,
    quoteName: quoteDetails?.quoteName,
    quoteNumber: quoteDetails?.quoteNumber,
    revisonNumber: getRevisionNumber(quoteDetails?.quoteNumber),
  };

  const productSummary = useProductSummaryMutate();

  const quoteDetailsAPI = useApiQuery<CartSummaryResponseTO>(
    `/quote-exp/v1/getquoteplandetails`,
    params,
    {
      gcTime: 0,
    }
  );

  if (
    quoteDetailsAPI.isSuccess &&
    quoteDetailsAPI?.data &&
    quoteDetailsAPI?.data?.planLine?.length > 0 &&
    productSummary.isIdle
  ) {
    const skuIds = quoteDetailsAPI?.data?.planLine.map(
      (plan: PlanLineTO) => `{'partNumber':'${plan.planId}','quantity':'1'}`
    );
    productSummary.mutate(skuIds?.join(','));
  }

  const isLoading = productSummary.isPending || quoteDetailsAPI.isLoading;
  const data: ProductSummaryTO[] | undefined =
    productSummary.data?.productSummaries;
  const totalOptions: TotalTO | undefined = productSummary.data?.total;

  return {
    data: {
      quoteSummary: quoteDetailsAPI.data,
      subOptions: data,
      total: totalOptions,
    },
    isLoading,
  };
}

function useProductSummaryMutate<To = ObjectMap>() {
  const apiGet = useApiGet<To>();
  return useMutation({
    mutationFn: (skulist: string) => {
      return apiGet(
        `/product/v1/productsummaries?q={'productIdentifiers':[${skulist}]}`
      );
    },
  });
}
